import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { SidePanelActionButton } from 'site-modules/canvas/components/side-panel-action-button/side-panel-action-button';
import './insider-action-button.scss';

export function InsiderActionButton({
  authAction,
  isAuthenticated = false,
  isAnonymousUser = false,
  toggleSignModal,
  signOut,
}) {
  const userFirstName = useSelector(state => state.profile?.data?.idm?.person?.firstName || '');
  const hasUserFirstName = userFirstName.trim().length > 0;
  if (!isAuthenticated || isAnonymousUser) {
    return (
      <SidePanelActionButton
        iconElement={<span className="icon-user3 size-16 text-cool-gray-50" aria-hidden="true" />}
        label="Register/Sign in"
        trackingId={authAction.signInTrackingId}
        trackingValue="Register/Sign in"
        onClick={toggleSignModal}
        buttonClassNames="mb-0 bg-cool-gray-80"
        hoverCopy="Register/Sign in"
        hoverCopyTextClassName="text-cool-gray-30"
      />
    );
  }

  return (
    <SidePanelActionButton
      iconElement={<span className="icon-user3 size-16 text-white" aria-hidden="true" />}
      label="Account options"
      buttonClassNames="mb-0 bg-blue-40"
      popoverClassName="profile-hover-panel"
      popoverContainerClassName="insider-action-button"
      hoverContent={
        <>
          {hasUserFirstName && (
            <div className="profile-name d-flex size-14 text-cool-gray-50 text-nowrap pt-0_5 pb-0_25 px-1 pos-r">
              {userFirstName}
            </div>
          )}
          <button
            className="sign-out-item pos-r d-flex w-100 align-items-center gap-0_5 border-0 bg-transparent text-cool-gray-30 size-16 px-1 py-0_5"
            type="button"
            onClick={signOut}
            // Explicit tabindex is needed for safari. Otherwise it ignores this button and it becomes unreachable from the keybaord
            tabIndex={0}
            data-tracking-id={authAction.signOutTrackingId}
            data-tracking-value="Sign out"
          >
            <svg width={16} height={16} viewBox="0 0 16 16" fill="inherit" aria-hidden="true">
              <path d="M2.177 16a1.9 1.9 0 0 1-1.399-.578 1.9 1.9 0 0 1-.578-1.4V1.978q0-.821.578-1.4A1.9 1.9 0 0 1 2.178 0h5.074q.417 0 .703.286.285.286.286.703a.96.96 0 0 1-.286.702.96.96 0 0 1-.703.287H2.177v12.044h5.075q.417 0 .703.287.285.286.286.702a.96.96 0 0 1-.286.703.96.96 0 0 1-.703.286zm10.25-7.011H6.54a.96.96 0 0 1-.702-.286A.96.96 0 0 1 5.55 8q0-.416.287-.703a.96.96 0 0 1 .702-.286h5.889l-1.51-1.51a.92.92 0 0 1-.276-.675q0-.4.276-.692a.93.93 0 0 1 .689-.305.94.94 0 0 1 .71.289l3.191 3.19A.96.96 0 0 1 15.8 8a.96.96 0 0 1-.292.692l-3.19 3.19a.92.92 0 0 1-.7.29.98.98 0 0 1-.7-.306.95.95 0 0 1-.268-.7q.008-.408.284-.683z" />
            </svg>
            <span>Sign out</span>
          </button>
        </>
      }
    />
  );
}

InsiderActionButton.propTypes = {
  authAction: PropTypes.shape({
    creativeId: PropTypes.string.isRequired,
    signInTrackingId: PropTypes.string.isRequired,
    signOutTrackingId: PropTypes.string.isRequired,
  }).isRequired,
  isAuthenticated: PropTypes.bool,
  isAnonymousUser: PropTypes.bool,
  toggleSignModal: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired,
};
